import React, { useState } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import projectData from '../data/projects';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, Image } from 'pure-react-carousel';

const Projects = () => {

  const [projects, setProjects] = useState(projectData);
  const [project, setProject] = useState(null);
  const [modalIsOpen, setIsOpen] = useState(false);

  const setActive = (id) => {
    const items = ["1", "2", "3", "4", "5"];
    setProjects([]);
    items.forEach(i => {
      if(i !== id){
        document.getElementById(i).classList.remove("bar-active");
      }
      else{
        const ele = document.getElementById(id);
        ele.classList.add("bar-active");
        const type = ele.dataset.filter;
        if(type === "all"){
          setTimeout(() => setProjects(projectData), 10);
        }
        else{
          const filterData = projectData.filter(project => project.type === type);
          setTimeout(() => setProjects(filterData), 10);
        }
      }
    });
  }

  const handleOutsideClick = (e) => {
    const carousel = document.querySelector(".carousel");
    if(!carousel.contains(e.target)){
      setIsOpen(false);
    }
  }

  return (
    <section id="projects">
      <ScrollAnimation animateOnce={true} animateIn="fadeInLeft" >
        <div className="header">
          <div className="headerText">
            <span>PROJECTS</span>
            <ScrollAnimation animateOnce={true} className="headerBar" delay={500} animateIn="fadeInLeft">
            </ScrollAnimation>
          </div>
        </div>
      </ScrollAnimation>
      <ScrollAnimation className="flex-box" animateOnce={true} animateIn="fadeIn">
        <div className="flex-bar">
          <div id="1" className="bar-items bar-active" onClick={e => setActive(e.target.id)} data-filter="all">
            ALL
          </div>
          <div id="2" className="bar-items" onClick={e => setActive(e.target.id)} data-filter="react">
            REACT-JS
          </div>
          <div id="3" className="bar-items" onClick={e => setActive(e.target.id)} data-filter="angular">
            ANGULAR
          </div>
          <div id="4" className="bar-items" onClick={e => setActive(e.target.id)} data-filter="rails">
            RUBY/RAILS
          </div>
          <div id="5" className="bar-items" onClick={e => setActive(e.target.id)} data-filter="java">
            JAVA/SPRING
          </div>
        </div>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" className="gallery" animateOnce={true}>
        {projects.map(project =>
          <div className="card" style={{ background: `url(${project.img[0]}) center center/cover` }} key={project.id}>
            <div className="overlay-card">
              <div className="project-header">
                <span className="project-title">{project.name}</span>
                <span className="project-stack">{project.stack}</span>
              </div>
              <div className="view-btn" onClick={() => { 
                setProject(project);
                setIsOpen(true);
                }}>
                View More
              </div>
            </div>
          </div>
        )}
      </ScrollAnimation>
      {modalIsOpen === true &&
        <div className="modal" onClick={e => handleOutsideClick(e)}>
          <CarouselProvider
            naturalSlideWidth={100}
            naturalSlideHeight={100}
            totalSlides={3}
          >
          <Slider classNameAnimation="slider-transition">
              {project !== null ? (
                project.img.map((image, i) => (
                  <Slide key={i} index={i}>
                    <Image src={image} alt="" className="modal-img" />
                  </Slide>
                ))) : (
                ""
              )
              }
            </Slider>
            <div className="modal-desc">
              <span className="modal-project-title">{project.name}</span>
              <div className="divider"></div>
              <span className="modal-project-desc">{project.desc}</span>
              <div className="modal-grp">
                {project.url ? (
                  <a href={project.url} target="_blank" rel="noreferrer">
                    <div className="modal-btn">
                      <span className="iconify url-icon" data-icon="eva:external-link-outline" data-inline="false"></span>
                      <span>VIEW SITE</span>
                    </div>
                  </a>
                ) : <div></div>
                }
                <div onClick={() => setIsOpen(false)}>
                  <span className="iconify close-icon" data-icon="akar-icons:cross" data-inline="false"></span>
                </div>
              </div>
            </div>
            <div className="btn-group">
              <ButtonBack className="btn-move">
                <span className="iconify arrow-icon" data-icon="dashicons:arrow-left-alt2" data-inline="false"></span>
              </ButtonBack>
              <ButtonNext className="btn-move">
                <span className="iconify arrow-icon" data-icon="fe:arrow-right" data-inline="false"></span>
              </ButtonNext>
            </div>
          </CarouselProvider>
        </div>
      }
    </section>
  )
}

export default Projects;
